import KButton from "./KButton.vue";
export default KButton;
